import React, { useEffect, useState } from "react";
import { getAllContacts } from "../utils/contact";
import ContactFilters from "../pages/ContactFilters";
import ExportExcel from "./ExportExcel";


const ITEMS_PER_PAGE = 10;

const ContactContent = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedYear, setSelectedYear] = useState("all");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedNumber, setSelectedNumber] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedService, setSelectedService] = useState([]);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);

  const handleResetFilters = () => {
    setSelectedMonth("all");
    setSelectedYear("all");
    setSelectedDate("");
    setSelectedNumber("");
    setSearchQuery("");
    setSelectedService([]);
    setCurrentPage(1);
  };

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await getAllContacts();
        setContacts(response.data);
      } catch (error) {
        console.error("Failed to fetch contact data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContacts();
  }, []);

  const startYear = 2025;
  const endYear = 2025;
  const allYears = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
  const uniqueYears = allYears.sort((a, b) => b - a);

  const filteredContacts = contacts.filter((contact) => {
    const date = new Date(contact.created_at);
    const contactMonth = date.getMonth() + 1;
    const contactYear = date.getFullYear();
    const formattedDate = date.toISOString().split("T")[0];

    const monthMatch = selectedMonth === "all" || contactMonth === parseInt(selectedMonth, 10);
    const yearMatch = selectedYear === "all" || contactYear === parseInt(selectedYear, 10);
    const dateMatch = !selectedDate || formattedDate === selectedDate;
    const numberMatch = !selectedNumber || contact.phone.includes(selectedNumber);
    const searchMatch = [contact.first_name, contact.last_name, contact.email, contact.message]
      .some((field) => field?.toLowerCase().includes(searchQuery.toLowerCase()));

    const contactServices = (() => {
      try {
        if (Array.isArray(contact.services)) return contact.services;
        return JSON.parse(contact.services);
      } catch {
        return [contact.services];
      }
    })();

    const normalizedSelected = selectedService.map(s => s.trim().toLowerCase());
    const normalizedContactServices = contactServices.map(s => s.trim().toLowerCase());

    const serviceMatch =
      normalizedSelected.length === 0 ||
      normalizedContactServices.some((s) => normalizedSelected.includes(s));

    return monthMatch && yearMatch && dateMatch && numberMatch && searchMatch && serviceMatch;
  });

  const displayedCount = currentPage * ITEMS_PER_PAGE;
  const currentContacts = filteredContacts.slice(0, displayedCount);

  console.log(currentContacts, filteredContacts,"data")

  return (
    <div className="bg-white p-4 shadow rounded-md mb-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="flex justify-center text-2xl font-bold text-[#0C1832]">Contact Details</h2>

        <ContactFilters
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          selectedDate={selectedDate}
          selectedNumber={selectedNumber}
          searchQuery={searchQuery}
          selectedService={selectedService}
          handleMonthChange={(e) => { setSelectedMonth(e.target.value); setCurrentPage(1); }}
          handleYearChange={(e) => { setSelectedYear(e.target.value); setCurrentPage(1); }}
          handleDateChange={(e) => { setSelectedDate(e.target.value); setCurrentPage(1); }}
          handleNumberChange={(e) => { setSelectedNumber(e.target.value); setCurrentPage(1); }}
          handleSearchChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
          handleServiceChange={(e) => {
            const { value, checked } = e.target;
            setSelectedService((prev) =>
              checked ? [...prev, value] : prev.filter((s) => s !== value)
            );
            setCurrentPage(1);
          }}
          uniqueYears={uniqueYears}
          handleResetFilters={handleResetFilters}
        />

        <div className="mb-4 flex justify-end">
        </div>
        <div className="flex justify-end mb-8">
          <ExportExcel data={currentContacts} />
        </div>

        {loading ? (
          <p className="text-gray-400">Loading...</p>
        ) : filteredContacts.length === 0 ? (
          <p className="text-gray-400">No contacts found.</p>
        ) : (
          <>
            <div className="overflow-x-auto rounded-lg border bg-white shadow-md">
              <table className="min-w-full">
                <thead className="bg-[#0D283F] text-white hidden sticky lg:table-header-group ">
                  <tr>
                    <th className="py-2 px-4 text-left">S.No.</th>
                    <th className="py-2 px-4 text-left">Date</th>
                    <th className="py-2 px-4 text-left">First Name</th>
                    <th className="py-2 px-4 text-left">Last Name</th>
                    <th className="py-2 px-4 text-left">Email</th>
                    <th className="py-2 px-4 text-left">Phone</th>
                    <th className="py-2 px-4 text-left">Service</th>
                    <th className="py-2 px-4 text-left">Message</th>
                  </tr>
                </thead>
                <tbody>
                  {currentContacts.map((contact, index) => {
                    const isExpanded = expandedRowIndex === index;

                    const formatService = (s) =>
                      s.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

                    const services = (() => {
                      try {
                        if (Array.isArray(contact.services)) return contact.services;
                        return JSON.parse(contact.services);
                      } catch {
                        return [contact.services];
                      }
                    })();

                    const formattedServices = services.map(formatService).join(", ");

                    const tdClasses = isExpanded
                      ? "py-2 px-4"
                      : "py-2 px-4 truncate whitespace-nowrap overflow-hidden max-w-[150px]";

                    return (
                      <tr
                        key={contact.id}
                        className="border-b hover:bg-gray-100 cursor-pointer"
                        onClick={() =>
                          setExpandedRowIndex((prev) => (prev === index ? null : index))
                        }
                      >
                        <td className={tdClasses}>{index + 1}</td>
                        <td className={tdClasses}>
                          {new Date(contact.created_at).toLocaleDateString()}
                        </td>
                        <td className={tdClasses}>{contact.first_name}</td>
                        <td className={tdClasses}>{contact.last_name}</td>
                        <td className={tdClasses}>{contact.email}</td>
                        <td className={tdClasses}>{contact.phone}</td>
                        <td className={`${tdClasses} capitalize`}>{formattedServices}</td>
                        <td className={tdClasses}>{contact.message}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {displayedCount < filteredContacts.length && (
              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-[#0D283F] text-white rounded hover:bg-blue-700 transition"
                >
                  Load 10 More
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ContactContent;
